import { render } from "./confirmarPedidoADistribuidor.vue?vue&type=template&id=0e8581b5&scoped=true"
import script from "./confirmarPedidoADistribuidor.vue?vue&type=script&lang=js"
export * from "./confirmarPedidoADistribuidor.vue?vue&type=script&lang=js"

import "./confirmarPedidoADistribuidor.vue?vue&type=style&index=0&id=0e8581b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e8581b5"]])

export default __exports__